import { render, staticRenderFns } from "./SubImagens.vue?vue&type=template&id=6517fd29&scoped=true&"
import script from "./SubImagens.vue?vue&type=script&lang=js&"
export * from "./SubImagens.vue?vue&type=script&lang=js&"
import style0 from "./SubImagens.vue?vue&type=style&index=0&id=6517fd29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517fd29",
  null
  
)

export default component.exports